export const SESSION_KEY_BACK_URL = 'BACK-URL'
